import React from 'react';
import { Stack } from 'expo-router';

// ─────────────────────────────────────────────────────────────────────────────

export default function MenuTabLayout() {
  return <Stack screenOptions={SCREEN_OPTIONS} />;
}

// ─── Constants ───────────────────────────────────────────────────────────────

const SCREEN_OPTIONS = {
  headerShown: false,
};
